import styled, { css } from 'styled-components'

import { FlexAlignItemsCenter } from 'components/common/genericStyles'
import { Color } from 'constants/color'
import { isDesktop } from 'utils/device'

export const Button = styled.button`
    width: max-content;
    height: max-content;
    margin: 6px 0;
    background-color: #ffffff;
    border-radius: 10px;
    color: #555555;
    fill: #555555;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    outline: none;
    border: none;
    cursor: pointer;
    padding: 6px 15px;
    transition: 1s ease in;
    border: 1px solid #e0e0e0;

    ${props =>
        props.disabled &&
        css`
            background: #c4c4c4;
            border: 1px solid #c4c4c4;
            cursor: default;
            & > img {
                filter: brightness(4);
            }
        `}

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        font-size: x-small;
    }

    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
        font-size: x-small;
    }

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        font-size: smaller;
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
        font-size: small;
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
        font-size: small;
    }

    @media (min-width: 1366px) {
        font-size: 18px;
    }

    /* 4K Screens */
    @media (min-width: 2560px) {
        font-size: 18px;
    }
`
export const TopThreeButtons = styled.div`
    button {
        margin-top: 12px;
        @media only screen and (max-width: 900px) {
            margin-top: 0;
        }
    }
    @media only screen and (max-width: 992px) {
        flex-direction: row;
        display: flex;
    }
`

export const GestureContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-bottom: 6px;
`

export const RedButtonOnDisable = styled(Button)`
    width: 35px;
    height: 35px;
    border-radius: 50%;
    font-size: 16px;
    font-family: Avenir;
    align-self: flex-end;
    padding: 0px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${!isDesktop &&
        css`
            width: 50px;
            height: 50px;
        `}

    ${props =>
        props.isMobile &&
        css`
            margin: 5px 10px;
        `}
    ${props =>
        props.clicked &&
        css`
            background-color: #e87d7c;
            border: 1px solid #e87d7c;
            &:hover {
                border: 1px solid #c4c4c4;
                background-color: #e87d7c;
            }
        `}
`

export const CloseIconDiv = styled.div`
    display: flex;
    justify-content: center;
    ${props =>
        props.isMobile &&
        css`
            margin-bottom: 0px;
        `}
`

export const MenuButton = styled(Button)`
    width: 35px!important;
    height: 35px!important;
    border-radius: 50%;
    font-size: 16px;
    font-family: Avenir;
    align-self: flex-end;
    padding: 0px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media only screen and (min-width: 1024px) and (max-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
       align-self: flex-start;
    }

    :disabled{
        opacity: 0.5;
        background-color: #fff;
        ${() =>
            !isDesktop &&
            css`
                background-color: #333;
            `}
        pointer-events: none;
    }
    :disabled img {
        filter: brightness(1);
    }

    ${props =>
        props.isMobile &&
        css`
            margin: 5px 10px;
        `}
    ${props =>
        props.clicked &&
        css`
            background-color: #e87d7c;
            border: 1px solid #e87d7c;
            &:hover {
                border: 1px solid #c4c4c4;
                background-color: #e87d7c;
            }
        `}
    ${props =>
        props.primary &&
        css`
            background-color: #e87d7c;
            border: 1px solid #e87d7c;
            &:hover {
                border: 1px solid #c4c4c4;
            }
        `}
    ${props =>
        props.hasContainer &&
        css`
            margin: 0;
        `}
    ${props =>
        props.enableTooltipOnDisable &&
        css`
            margin: 8px 0;
            height: 33px;
        `}
    ${() =>
        !isDesktop &&
        css`
            background-color: #333;
            border: none;
            width: 50px !important;
            height: 50px !important;
        `}
`

export const EmojiWrapper = styled.div`
    height: 24px;
    width: 24px;
`

export const GestureButton = styled(MenuButton)`
    margin-left: 2px !important;
`

export const EndCallButtonStyle = styled(MenuButton)`
    ${!isDesktop &&
        css`
            margin: 0px;
            background-color: #e87d7c;
        `}
`

export const HamToggleButton = styled(Button)`
    width: 35px;
    height: 35px;
    border-radius: 50% 50% 50% 0;
    font-size: 16px;
    font-family: Avenir;
    align-self: flex-end;
    padding: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => (props.isWhiteboardOpen ? '#e87d7c' : '#fff')};
    ${props =>
        props.isMobile &&
        css`
            margin: 5px 10px;
        `}
    ${props =>
        props.clicked &&
        css`
            // margin-left: 2px;
        `}
`

export const GreyButtonOnDisable = styled(Button)`
    width: 35px;
    height: 35px;
    border-radius: 50%;
    font-size: 16px;
    font-family: Avenir;
    align-self: flex-end;
    padding: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${props =>
        props.isMobile &&
        css`
            margin: 5px 10px;
        `}
    ${props =>
        props.clicked &&
        css`
            background-color: #c4c4c4;
        `}
    ${props =>
        props.hasContainer &&
        css`
            margin: 0;
        `}
`

export const ModeListButton = styled(Button)`
    width: 35px;
    height: 35px;
    border-radius: 50%;
    font-size: 16px;
    font-family: Avenir;
    align-self: flex-end;
    padding: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor:pointer;
    ${props =>
        props.isMobile &&
        css`
            margin: 5px 10px;
        `}
    ${props =>
        props.clicked &&
        css`
            background-color: #e87d7c;
            border: 1px solid #e87d7c;
            &:hover {
                border: 1px solid #c4c4c4;
                background-color: #e87d7c;
            }
        `}
        ${props =>
            props.disabled &&
            css`
                cursor: auto;
                background-color: #c4c4c4;
                border: 1px solid #c4c4c4;
                & > img {
                    filter: brightness(4);
                }
            `}
            margin-left: 2px !important;

`

export const BlackButtonOnActive = styled(ModeListButton)``

export const HamIcon = styled.img`
    width: 20px;
    height: 20px;
    color: #555555;

    ${props =>
        props.clicked &&
        css`
            filter: brightness(1);
        `}
    ${props =>
        props.isWhiteboardOpen &&
        css`
            filter: brightness(0) saturate(100%) invert(100%) sepia(0%)
                saturate(7476%) hue-rotate(110deg) brightness(98%)
                contrast(108%);
        `}
`

export const ScreenShareButton = styled(ModeListButton)`
    margin-left: 2px !important;
`

export const IframeShareButton = styled(ModeListButton)`
    margin-left: 2px !important;
    ${({ isIframeShared }) => {
        if (isIframeShared) {
            return `
                background-color: #e87d7c;
                border: 1px solid #e87d7c;
                &:hover {
                    border: 1px solid #c4c4c4;
                }
            `
        }
    }}
`

export const TroubleshootButton = styled(MenuButton)`
    margin-left: 2px !important;
`

export const ShortcutButton = styled(MenuButton)`
    margin-left: 2px !important;
`

export const RefreshButton = styled(MenuButton)`
    margin-left: 2px !important;
`

export const MuteAllButton = styled(MenuButton)`
    margin-left: 2px !important;
    &:active {
        transform: translateY(2px);
        background-color: #e87d7c;
    }
    ${props =>
        props.enableTooltipOnDisable &&
        css`
            margin: 8px -2px;
            height: 35px;
        `}
    ${props =>
        props.isMobile &&
        css`
            margin: 5px 10px;
        `}
`

export const NoteUploadButton = styled(MenuButton)`
    margin-left: 2px !important;
    background: transparent;
    border: none;
    ${props =>
        props.enableTooltipOnDisable &&
        css`
            margin: 8px -2px;
            height: 35px;
        `}
    ${props =>
        props.isMobile &&
        css`
            margin: 5px 10px;
        `}
`

export const MuteAllIcon = styled.img`
    width: 18px;
    height: 18px;
    color: ${Color.ohGrey};

    ${props =>
        props.clicked &&
        css`
            filter: brightness(4);
        `}
`

export const NoteUploadIcon = styled.img`
    width: 18px;
    height: 18px;
    color: ${Color.ohGrey};
`

export const IframeShareIcon = styled.img`
    width: 18px;
    height: 18px;
    color: ${Color.ohGrey};
`

export const ScreenShareIcon = styled.img`
    width: 20px;
    height: 20px;
    ${props =>
        props.clicked &&
        css`
            filter: brightness(4);
        `}
`

export const WhiteboardIcon = styled.img`
    width: 22px;
    height: 22px;
    color: #555555;

    ${props =>
        props.clicked &&
        css`
            filter: brightness(0) saturate(100%) invert(100%) sepia(0%)
                saturate(7476%) hue-rotate(110deg) brightness(98%)
                contrast(108%);
        `}
`

export const WhiteboardButton = styled(ModeListButton)`
    margin-left: 2px !important;
    background-color: transparent;
    border: none;
    ${props =>
        props.enableTooltipOnDisable &&
        css`
            margin: 8px -2px;
            height: 35px;
        `}
`

export const QuizButton = styled(ModeListButton)`
    margin-left: 2px !important;
    ${props =>
        props.enableTooltipOnDisable &&
        css`
            margin: 8px -2px;
            height: 35px;
        `}
`

export const QuizIcon = styled.img`
    width: 18px;
    height: 18px;
    color: #555555;

    ${props =>
        props.clicked &&
        css`
            filter: brightness(4);
        `}
`

export const MenuIcon = styled.img`
    width: 20px;
    height: 20px;

    ${!isDesktop &&
        css`
            width: 25px;
            height: 25px;
        `}
    color: #555555;

    ${props =>
        props.clicked &&
        css`
            filter: brightness(0) saturate(100%) invert(100%) sepia(0%)
                saturate(7476%) hue-rotate(110deg) brightness(98%)
                contrast(108%);
        `}
`

export const FullScreenIcon = styled.img`
    width: 12px;
    height: 12px;
    color: #555555;

    ${props =>
        props.clicked &&
        css`
            filter: brightness(0) saturate(100%) invert(100%) sepia(0%)
                saturate(7476%) hue-rotate(110deg) brightness(98%)
                contrast(108%);
        `}
`

export const ControlsWrapper = styled.div`
    height: 100vh;
    display: flex;
    position: fixed;
    flex-direction: column;
    width: 100%;
    align-items: center;
    top: 12px;
    z-index: 999;
    transition: opacity 0.6s, transform 0.6s, visibility 0s;
    opacity: 1;
    visibility: visible;
    max-width: min-content;
    margin-top: 10px;
    margin-bottom: 10px;
    justify-content: space-between;
    ${props =>
        props.isMobile &&
        css`
            flex-direction: row;
            top: unset;
            bottom: 0;
            left: 0;
            margin: unset;
        `}

    ${props =>
        props.isHAM &&
        css`
            position: unset;
        `}
`

export const TopButtonContainer = styled.div`
    @media only screen and (max-width: 992px) {
        flex-direction: row;
        display: flex;
    }
`

export const BottomButtonContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media only screen and (max-width: 900px) {
        position: absolute;
        right: 0;
        width: 35px;
        height: 35px;
    }
`

export const SeperatorLine = styled.div`
    width: 90%;
    background: #e0e0e0e0;
    height: 1px;
    border-radius: 5px;
    margin: 12px 0;
`

export const SeperatorLineNew = styled(SeperatorLine)`
    margin: 12px 0 6px;
`

export const ControlsHAMWrapper = styled.div`
    display: flex;
    position: fixed;
    top: 12px;
    flex-direction: column;
    z-index: 999;
    transition: opacity 0.6s, transform 0.6s, visibility 0s;
    opacity: 1;
    visibility: visible;
    max-width: min-content;
    margin-top: 15px;

    @media only screen and (max-width: 900px) {
        flex-direction: row;
        top: unset;
        bottom: 0;
        left: 0;
        margin-top: 0;
    }
    ${props =>
        props.isHAM &&
        css`
            position: unset;
        `}

    ${props =>
        props.notOpened &&
        css`
            display: none;
        `}
`

export const HamburgerMenuWrapper = styled.div`
    width: auto;
    height: auto;
    position: relative;
    ${props =>
        props.isMobile &&
        css`
            display: flex;
        `}
`

export const WrapperDiv = styled.div`
    display: flex;
    z-index: 5;
    transition: 1s ease in;
    // &:hover {
    //     filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.5));
    //     transition: 1s ease in;
    // }
    ${props =>
        props.isMobile &&
        css`
            width: unset;
            margin: unset;
        `}
`

export const TooltipWrapperEmptyDiv = styled.div``

export const TickMarkWrapper = styled.div`
    width: 30px;
    height: 30px;
`

export const Text = styled.div`
    padding: 10px 8px;
    font-size: 15px;
    color: #000;
    cursor: pointer;
    ${props =>
        props.isClicked &&
        css`
            color: #e87d7c;
        `};
    ${props =>
        props.isDisabled &&
        css`
            color: #555;
            pointer-events: none;
        `};
`

export const WhiteboardModesText = styled(Text)`
    font-family: Avenir;
    color: #fff;
    ${FlexAlignItemsCenter}
`

export const SettingsListWrapper = styled.div`
    padding: 10px 5px 10px 20px;
`
